/* =========================================================
   Cortenstyle - Judge.me reviews
   1. Eigen navigatie (pijlen + bolletjes) onder de review-slider
   2. Klik op de beoordelingsregel onder de koopknoppen scrollt naar de slider
   ========================================================= */

/* 1. Navigatie onder de slider */
(function () {
  function build(widget) {
    if (widget.dataset.csNav) return;
    var id = widget.getAttribute('data-jdgm-block-id');
    var mode = window.jdgmCarouselMode && window.jdgmCarouselMode[id];
    var content = widget.querySelector('.jdgm-content');
    if (!id || !mode || !content) return;
    widget.dataset.csNav = '1';

    var total = mode.revCount;
    var nav = document.createElement('div');
    nav.className = 'cs-nav';

    function arrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cs-nav__arrow cs-nav__arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Vorige review' : 'Volgende review');
      b.innerHTML = dir === 'prev'
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
      b.addEventListener('click', function () {
        if (dir === 'prev') window.jdgmPreviousCard(id); else window.jdgmNextCard(id);
      });
      return b;
    }

    var dots = document.createElement('div');
    dots.className = 'cs-nav__dots';
    for (var i = 0; i < total; i++) {
      (function (n) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'cs-nav__dot';
        d.setAttribute('aria-label', 'Ga naar review ' + (n + 1));
        d.addEventListener('click', function () {
          var m = window.jdgmCarouselMode[id];
          if (!m || m.index === n) return;
          m.index = (n - 1 + m.revCount) % m.revCount;
          window.jdgmNextCard(id);
        });
        dots.appendChild(d);
      })(i);
    }

    nav.appendChild(arrow('prev'));
    nav.appendChild(dots);
    nav.appendChild(arrow('next'));
    content.insertAdjacentElement('afterend', nav);

    function update() {
      var m = window.jdgmCarouselMode[id];
      if (!m) return;
      var all = dots.children;
      for (var j = 0; j < all.length; j++) {
        all[j].classList.toggle('is-active', j === m.index);
      }
    }
    update();
    var track = widget.querySelector('.jdgm-videos-container');
    if (track) new MutationObserver(update).observe(track, { attributes: true, attributeFilter: ['style'] });
  }

  function init() {
    document.querySelectorAll('.jdgm-cards-carousel[data-jdgm-block-id]').forEach(build);
  }

  var tries = 0;
  var timer = setInterval(function () {
    init();
    if (++tries > 40) clearInterval(timer);
  }, 250);
})();

/* 2. Beoordelingsregel scrollt naar de slider */
document.addEventListener('click', function (e) {
  var link = e.target.closest('.jdgm-all-reviews-text a');
  if (!link) return;
  var target = document.querySelector('.jdgm-cards-carousel');
  if (!target) return;
  e.preventDefault();
  var header = document.querySelector('.section-header, sticky-header, .header-wrapper');
  var offset = header ? header.getBoundingClientRect().height + 24 : 24;
  var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: top, behavior: 'smooth' });
}, true);